import React, { useState } from 'react';
import classNames from 'classnames';
import Logo from './Logo';
import { ContactStyle } from '../styles/contact.style';

const Contact = ({ onFootSelect, activeNav }) => {
  const contactBg = 'https://res.cloudinary.com/dahddvlgy/image/upload/v1652292190/mad_wallet/images/contact_us_new_mad_wallet.pngd.png';
  
  const [contact, setContact] = useState(false);

  return (
    <ContactStyle bg={contactBg}>
      <div className="footer__content--box">
        <div className="footer__logo">
          <Logo section="footer"/>
        </div>
          <nav className='footer__nav-list'>
      <div 
      className={classNames('footer__nav-item',{
        'activeLink': activeNav === 'landing'
      })}
      onClick={(e) => onFootSelect(e)}
      >
        <button className='footer__nav-link' name="landing">Home</button>
      </div>
      <div className={classNames('footer__nav-item',{
          'activeLink': activeNav === 'features'
        })}
      onClick={(e) => onFootSelect(e)}
      >
        <button className='footer__nav-link' name="features">Features</button>
      </div>
      <div className={classNames('footer__nav-item', {
          'activeLink': activeNav === 'madverse'
        })}
      onClick={(e) => onFootSelect(e)}
      >
        <button className='footer__nav-link' name="madverse">Madverse</button>
      </div>
      <div className={classNames('footer__nav-item', {
          'activeLink': activeNav === 'newsletter'
        })}
      onClick={(e) => onFootSelect(e)}
      >
        <button className='footer__nav-link' name="newsletter">News</button>
      </div>
      <div className={classNames('footer__nav-item', {
          'activeLink': activeNav === 'community'
        })}
      onClick={(e) => onFootSelect(e)}
      >
        <button className='footer__nav-link' name="community">Community</button>
      </div>
      <div className="footer__nav-item lang"><span className="nav-links">En</span></div>
    </nav>

        <div className={classNames('footer__contact', {
          'active': contact
        })} onClick={() => setContact(true)}>
          <h3 className="contact__us">contact us</h3>
        </div>

        <div className="footer--copyright">
          <p className="copyright">&copy; Copyright All rights reserved, 2022.</p>
        </div>
      </div>
    </ContactStyle>
  )
}

export default Contact
